<template>
    <div class="container">
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col cols="11">
                        <v-card-title class="titulopagina">ADMINISTRAR EQUIPOS PLANTA</v-card-title>
                    </v-col>
                    <v-col cols="1">
                        <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas">
                            <v-icon color="blue" large>help</v-icon>
                        </v-alert>
                    </v-col>
                </v-row>                
            </v-card-text>
        </v-card>
        <modal-ayuda></modal-ayuda>
        <v-card> 
            <v-card-text>
                <v-btn color="green" fab small dark @click="crear">
                    <v-icon>add</v-icon>
                </v-btn>
            </v-card-text>
        </v-card>

        <data-table-filtro class="mt-5" @editar="editar($event)"></data-table-filtro>

        <modal @peticionrealizada="cargarDatos"></modal>
    </div>
</template>
<script>
import {mapState, mapMutations} from 'vuex';
import Data_Table from '@/components/shared/Data_Table.vue';
import Modal from '@/components/shared/Modal.vue';
import Data_Table_Filtro from "@/components/shared/Data_Table_Filtro";
import ModalAyudas from '@/components/shared/ModalAyudas.vue';

export default {
    data: () => ({
        lista: [],
        puntos_medicion:[],
        equipos_proceso:[],
        inputs: [
            {tipo:'select',valor:'', label:'Seleccione Punto de Medición*', key:'punto_mediciones_id', opciones:[], texto:'nombre_punto', seleccion:'id'},
            {tipo: 'texto', valor: '', label: 'Nombre de Equipo*', key: 'nombre_equipo'},
            {tipo: 'select', valor:'', label:'Seleccione Equipo de Proceso*', key:'equipos_procesos_id', opciones:[], texto:'nombre_equipo', seleccion:'id'},
            {tipo: 'switch', valor:true, label: 'Activo*', key: 'activo'}
        ],
        configuracion_modal: {
            titulo_modal: '',
            boton_submit: '',
            ruta: '',
            tipo_peticion: ''
        },
        cabeceras: [
            {
                text: 'Nombre',
                align: 'center',
                sortable: true,
                filterable: true,
                busqueda:'',
                value: 'nombre_equipo',
                class: 'light-blue darken-3 titulo2',
            },
            {
                text: 'Equipos Proceso',
                align: 'center',
                sortable: true,
                filterable: true,
                busqueda:'',
                value: 'nombre_equipos_proceso',
                class: 'light-blue darken-3 titulo2',
            },
            {
                text: 'Punto Medicion',
                align: 'center',
                sortable: true,
                filterable: true,
                busqueda:'',
                value: 'nombre_punto',
                class: 'light-blue darken-3 titulo2',
            },
            {
                text: 'Activo',
                align: 'center',
                sortable: true,
                filterable: true,
                busqueda:'',
                value: 'activo',
                class: 'light-blue darken-3 titulo2',
            },
            {text: 'Acciones', value: 'action', sortable: false, align: 'center',class: 'light-blue darken-3 titulo2',},
        ],
        acciones: [
            {key: 'editar', titulo: 'Editar', visible: true}
        ]
    }),
    mounted() {
        this.cargarPuntosMedicion()
        this.cargarEquiposProceso()
        this.cargarDatos();
    },
    methods: {
        abrirAyudas(){
            const jiji = [
                {   titulo:`Ayuda de Administrar Equipos Planta`,    tipo:`titulo`},
                {   tipo:`label`,   texto:`En esta pantalla se crean, modifican y muestran todos los equipos de la planta creados en el sistema y si se encuentran activos o no.`},
                {   tipo:`label`,   texto:`- En la tabla se muestra cada equipo, proceso, punto de medición y si se encuentra activo o no.`},
                {   tipo:`label`,   texto:`- En la columna "Acciones", al pulsar en el botón con el icono del lápiz, se abrirá una ventana para poder modificar los datos de ese equipo en particular y si se encuentra activo o no. Para guardar los cambios, se debe pulsar el botón "Actualizar".`},
                {   tipo:`label`,   texto:`- Al pulsar el botón con el icono del "+", se abrirá una ventana en donde se puede agregar un nuevo equipo al sistema. Se debe rellenar los campos solicitados (punto medición, nombre, equipo de proceso y si está activo) y para finalizar se debe pulsar el botón "Crear".`},
            ];
            Event.$emit('mostrar_alert',jiji);
        },
        async cargarPuntosMedicion(){
            this.mostrarLoading({titulo:'Cargando Puntos de Medición...',color:'green'})

            let url = `${this.base_url}punto_medicion`;
            await this.axios.get(url,this.headers).then((response)=>{
                this.puntos_medicion = response.data.data;
                this.inputs[0].opciones = this.puntos_medicion;
                this.ocultarLoading();
            }).catch((error)=>{
                console.log('error',error);
                this.ocultarLoading();
            });
        },

        async cargarEquiposProceso(){
            this.mostrarLoading({titulo:'Cargando Equipos de Proceso...',color:'green'})

            let url = `${this.base_url}equipo_procesos`
            await this.axios.get(url,this.headers).then((response)=>{
                this.equipos_proceso = response.data.data
                this.inputs[2].opciones = this.equipos_proceso
            }).catch((error)=>{
                console.log('error',error);
            })
        },

        async cargarDatos() {
            this.mostrarLoading({titulo: 'Cargando Datos...', color: 'green'})

            let url = `${this.base_url}equipo_planta`;
            await this.axios.get(url, this.headers).then((response) => {
                this.lista = response.data.data;
                Event.$emit('inicializar_tabla', this.cabeceras, this.lista, this.acciones);
                this.ocultarLoading();
            }).catch((error) => {
                console.log(error);
                this.ocultarLoading();
            });
        },

        crear() {
            this.configuracion_modal.titulo_modal = 'Crear Equipo de Planta';
            this.configuracion_modal.boton_submit = 'Crear';
            this.configuracion_modal.ruta = 'equipo_planta';
            this.configuracion_modal.tipo_peticion = 'POST';
            this.$emit('abrir', this.inputs, this.configuracion_modal);
        },

        async editar($event) {
            await this.inputs.forEach(input => {
                Object.keys($event).forEach(key => {
                    let valor = $event[key];
                    if (input.key == key) {
                        if (key == 'activo'){
                           valor = valor == 'No' ?  false : true;
                        }
                        input.valor = valor;
                    }
                });
            });

            this.configuracion_modal.titulo_modal = 'Editar Equipo de Planta';
            this.configuracion_modal.boton_submit = 'Actualizar';
            this.configuracion_modal.ruta = `equipo_planta/${$event.id}`;
            this.configuracion_modal.tipo_peticion = 'PUT';
            this.$emit('abrir', this.inputs, this.configuracion_modal);
        },

        ...mapMutations(['mostrarLoading', 'ocultarLoading'])
    },

    computed: {
        ...mapState(['base_url', 'headers']),
    },

    components: {
        'data-table-filtro':Data_Table_Filtro,
        'modal': Modal,
        'data-table': Data_Table,
        'modal-ayuda': ModalAyudas,
    }
}
</script>
<style scoped>
    .titulo2{color: white !important; font-size: 1em !important; }
</style>